<template>
  <div id="container" class="container" @contextmenu="preventContextmenu" @copy="preventCopy" @mouseup="handleMouseUp">
    <main id="content" class="l-main" v-if="globalNavigationStore.selectedColor!=='' && currentQuestion">
      <!--Vertical layout-->
      <div v-if="globalNavigationStore.selectedColor==='kokugo'"
         class="p-question -kokugo p-question--vertical"
      >
        <question-information @click="stopQAModal=true" name="S3-9-close-btn">
          <template #chapterTitle>
            <button class="hamburger" @click="skillModal=true" v-if="accountStore.isDebug">
              <span style="line-height: 1;">☰</span>
            </button>
            <markdown-view
                    :class="{'debug-markdown': accountStore.isDebug}"
                    :rawText="selectedQuestionSetTitle" :souruby="accountStore.isDebugSouruby">
            </markdown-view>
          </template>
          <template #chapterPageNumber v-if="selectedQuestionPageRange">
            <div class="c-parts-text-page -question">P {{selectedQuestionPageRange}}</div>
          </template>
          <template #chapterCorrectWrongList>
            <question-correct-wrong
                :question-correct-wrong-list="workStore.questionCorrectWrongList"
                :position="qIndex">
            </question-correct-wrong>
          </template>
          <template #previousNextButton>
            <div class="previous-next-button" v-if="!workStore.isSearchQuestionById && !workStore.isPrevQuestionHistory">
              <div class="button-frame">
                <a href="javascript:void(0)" class="prev" :class="{'-disabled':!qIndex}" @click="skipPrev" :tabindex="-1" name="S3-9-prev-skip-btn"><span>前へ</span></a>
                <span class="delimiter"></span>
                <a href="javascript:void(0)" class="next" @click="skipNext" :tabindex="-1" name="S3-9-next-skip-btn"><span>次へ</span></a>
              </div>
            </div>
          </template>
        </question-information>

        <div class="p-question__inner" ref="refModQuestionInner">
          <div class="p-question__main">
            <div class="p-question__body">
              <div class="p-question__body__judge-question" ref="refQuestionBody">
                <markdown-view
                        :class="{'debug-markdown': accountStore.isDebug}"
                        :rawText="currentQuestion.text"
                        :workId="currentQuestion.work_id" :souruby="accountStore.isDebugSouruby">
                </markdown-view>
              </div>
              <div class="p-question__body__judge-answer" ref="refAnswerExplanation">
                <answer-explanation
                      :is-vertical="true"
                      :auto-grading-page="isAutoGrading"
                      :workId="currentQuestion.work_id"
                      :is-souruby="accountStore.isDebugSouruby"
                      :commentary="currentQuestion.commentary"
                      :is-debug="accountStore.isDebug"
                      :answer-explanations="getExplanationAnswer">
                </answer-explanation>
              </div>
            </div>
            <question-status
                tag-position="sideRight"
                :tag-label="getQuestionLabels" :tag-correct="getTagCorrect"
                :explanation-page="true"
                :is-tag-review-required="!getReviewTag"
                @click="toggleReviewTag()">
              <template #prevButton v-if="qIndex!==0">
                <a href="javascript:void(0)" class="prevBtn" @click="prevAnswer()" :tabindex="tabIndex" name="S3-9-prev-question-btn">
                  <div class="prevBtn__inner"></div>
                </a>
              </template>
            </question-status>
          </div>
          <answer-area :is-vertical="true" @body-height="questionBodyHeight()" page-name="S3-9">
            <template #helpTag>
              <question-help
                      @click="openModal($event)"
                      tag-position="sideLeft"
                      :is-hint="!!currentQuestion.hint"
                      :is-point="!!getPoint(currentQuestion.section_id)"
                      page-name="S3-9"
              >
              </question-help>
            </template>
            <template #answerButton>
              <button-blue @click="nextQuestion()" :tab-index="tabIndex" :is-vertical="true" :disabled="workStore.isDisabledButton" name="S3-9-next-question-btn">{{getAnswerButtonText}}</button-blue>
            </template>
            <template #answerList>
              <answer-text-verify-grading
                  :answers="answerVerify" :is-souruby="accountStore.isDebugSouruby" :is-vertical="true"
                  :auto-grading-page="isAutoGrading">
              </answer-text-verify-grading>
            </template>
            <template #questionId>
              <div class="codeText">
                qid:{{currentQuestion.work_id}}-{{currentQuestion.id}}
                <br>  
                <a class="reportLink" @click="reportModal=true">問題の誤り・不具合を報告</a>
              </div>
            </template>
          </answer-area>
        </div>
      </div>

      <!--Horizontal layout-->
      <div v-else
        :class="['p-question p-question--horizontal -'+ globalNavigationStore.selectedColor]"
      >
        <question-information @click="stopQAModal=true" name="S3-7-close-btn">
          <template #chapterTitle>
            <button class="hamburger" @click="skillModal=true" v-if="accountStore.isDebug">
              <span style="line-height: 1;">☰</span>
            </button>
            <markdown-view
                    :class="{'debug-markdown': accountStore.isDebug}"
                    :rawText="selectedQuestionSetTitle" :souruby="accountStore.isDebugSouruby">
            </markdown-view>
          </template>
          <template #chapterPageNumber v-if="selectedQuestionPageRange">
            <div class="c-parts-text-page -question">P {{selectedQuestionPageRange}}</div>
          </template>
          <template #chapterCorrectWrongList>
            <question-correct-wrong
                :question-correct-wrong-list="workStore.questionCorrectWrongList"
                :position="qIndex">
            </question-correct-wrong>
          </template>
          <template #previousNextButton>
            <div class="previous-next-button" v-if="!workStore.isSearchQuestionById && !workStore.isPrevQuestionHistory">
              <div class="button-frame">
                <a href="javascript:void(0)" class="prev" :class="{'-disabled':!qIndex}" @click="skipPrev" :tabindex="-1"><span>前へ</span></a>
                <span class="delimiter"></span>
                <a href="javascript:void(0)" class="next" @click="skipNext" :tabindex="-1"><span>次へ</span></a>
              </div>
            </div>
          </template>
        </question-information>
        <div class="p-question__main" id="jsQuestionHorizontal">
          <question-status
              tag-position="sideLeft"
              :tag-label="getQuestionLabels" :tag-correct="getTagCorrect"
              :explanation-page="true"
              :is-tag-review-required="!getReviewTag"
              @click="toggleReviewTag()">
          </question-status>
          <div class="p-question__body" ref="refModQuestionBody">
            <div class="p-question__body__judge-question" ref="refQuestionBody">
              <markdown-view
                      :class="{'debug-markdown': accountStore.isDebug}"
                      :rawText="currentQuestion.text"
                      :workId="currentQuestion.work_id" :souruby="accountStore.isDebugSouruby">
              </markdown-view>
            </div>
            <div class="p-question__body__judge-answer" ref="refAnswerExplanation">
              <answer-explanation
                      :auto-grading-page="isAutoGrading"
                      :workId="currentQuestion.work_id"
                      :is-souruby="accountStore.isDebugSouruby"
                      :commentary="currentQuestion.commentary"
                      :is-debug="accountStore.isDebug"
                      :answer-explanations="getExplanationAnswer"
                      :is-keyboard="isKeyboard">
              </answer-explanation>
            </div>
          </div>
          <question-help
                  @click="openModal($event)"
                  tag-position="sideRight"
                  :is-hint="!!currentQuestion.hint"
                  :is-point="!!getPoint(currentQuestion.section_id)"
                  page-name="S3-9"
          ></question-help>
        </div>
        <answer-area @body-height="questionBodyHeight()" page-name="S3-9">
          <template #answerButton>
            <button-blue @click="nextQuestion()" :tab-index="tabIndex" :arrow="true" :label-normal="true" :disabled="workStore.isDisabledButton" name="S3-9-next-question-btn">{{getAnswerButtonText}}</button-blue>
          </template>
          <template #prevButton v-if="qIndex!==0">
            <a href="javascript:void(0)" class="prevBtn" @click="prevAnswer()" :tabindex="tabIndex" name="S3-9-prev-question-btn">
              <div class="prevBtn__inner"></div>
            </a>
          </template>
          <template #answerList>
            <answer-text-verify-grading
                    :answers="answerVerify"
                    :is-souruby="accountStore.isDebugSouruby"
                    :is-english="subject_field==='英語'"
                    :is-keyboard="isKeyboard"
                    :is-science="isScience"
                    :auto-grading-page="isAutoGrading"
            ></answer-text-verify-grading>
          </template>
          <template #questionId>
            <div class="codeText">
              qid:{{currentQuestion.work_id}}-{{currentQuestion.id}}
              <a class="reportLink" @click="reportModal=true">問題の誤り・不具合を報告</a>
            </div>
          </template>
        </answer-area>
      </div>
      <!--For make focus cycle-->
      <span tabindex="0" @focus="focusFirstElement(0)"></span>
      <popup-modal v-model="stopQAModal" @close="stopQAModal=false" @close-layer="stopQAModal=false" name="S3-9-close-learning-btn">
        <template #main>
          <div class="c-popup-body__head">
            <p class="c-popup-body__head-title">
              学習を中断しますか？
            </p>
          </div>
          <div class="c-popup-body__titleBox">
            <div class="c-popup-body__titleBox-logout u-text-caution" v-if="workStore.isReviewQuestion || workStore.isPrevQuestionHistory || (workStore.mission !== null && workStore.mission.kind !== missionKind.NEW)">
              学習を中断した場合，ここまでの解答は<br>学習記録に残りませんので，ご注意ください。
            </div>
            <div class="c-popup-body__titleBox-logout" v-else>
              中断した場合は、その続きから再開することができます。
            </div>
          </div>
        </template>
        <template #footer>
          <div class="c-button -col2">
            <a @click="stopQAModal=false" name="S3-9-continue-learning-btn" class="c-button-white -medium -font-large">
              <span class="label">中断せず学習を続ける</span>
            </a>
            <button-blue @click="closeModal('stopAQModal')" :medium="true" :label-normal="true" name="S3-9-stop-learning-btn">学習を中断する</button-blue>
          </div>
        </template>
      </popup-modal>

      <!-- この項目のポイント -->
      <popup-modal v-model="pointModal" @close="closeModal('point')" @close-layer="pointModal=false"
        :is-point-hint-modal="true"
        name="S3-9-point-close-btn"
        :modal-position-vertical="globalNavigationStore.selectedColor==='kokugo'"
      >
        <template #main>
          <div class="pointBlock">
            <div class="fixed-title-area">
              <div class="title">この項目のポイント</div>
            </div>
            <div class="text">
              <markdown-view
                      :class="{'debug-markdown': accountStore.isDebug}"
                      :rawText="getPoint(currentQuestion.section_id)"
                      :workId="currentQuestion.work_id" :souruby="accountStore.isDebugSouruby">
              </markdown-view>
            </div>
          </div>
        </template>
      </popup-modal>

      <!-- ヒント -->
      <popup-modal v-model="hintModal" @close="closeModal('hint')" @close-layer="hintModal=false"
         :is-point-hint-modal="true"
         name="S3-9-hint-close-btn"
         :modal-position-vertical="globalNavigationStore.selectedColor==='kokugo'"
      >
        <template #main>
          <div class="hintBlock">
            <div class="fixed-title-area">
              <div class="title">ヒント</div>
            </div>
            <div class="text">
              <markdown-view
                      :class="{'debug-markdown': accountStore.isDebug}"
                      :rawText="currentQuestion.hint"
                      :workId="currentQuestion.work_id" :souruby="accountStore.isDebugSouruby">
              </markdown-view>
            </div>
          </div>
        </template>
      </popup-modal>
      <!--Skill modal-->
      <popup-modal v-model="skillModal" @close="skillModal=false" @close-layer="skillModal=false" :is-help-modal="true">
        <template #main>
          <div class="topNoticeBlock">
            <div class="text">
              スキル: {{allSkills()}}
            </div>
            <div class="text" v-if="getCheckFormulaAsString.length">
              答えを文字列一致のみで判定する
              <ul>
                <li v-for="(quiz,index) in getCheckFormulaAsString">
                  解答欄{{index+1}}<span v-if="quiz.label">({{quiz.label}})</span> : <span v-if="quiz.body.checkFormulaAsString">有効</span><span v-else>無効</span>
                </li>
              </ul>
            </div>
            <div class="text">
              解答形式
              <ul>
                <li v-for="(quiz,index) in getAnswerFormat">
                  解答欄{{index+1}}<span v-if="quiz.label">({{quiz.label}})</span> : <span>{{quiz.answer_format}}</span>
                </li>
              </ul>
            </div>
            <div class="text">
              <div>総ルビ表示の設定:</div>
              <div class="c-parts-toggle" :class="{'c-parts-toggle--active': accountStore.isDebugSouruby}" @click="toggleRubySwitch()">
                <span class="label">{{accountStore.isDebugSouruby?'ON':'OFF'}}</span>
                <span class="toggle"></span>
              </div>
            </div>
            <br>
            <div class="text">
              <button-blue :small="true" @click="resolvePrevious()">解き直す</button-blue>
            </div>
          </div>
        </template>
      </popup-modal>
      <!-- report modal -->
      <error-report-modal 
        v-model="reportModal"
        sid="S3-9" 
        :subject="subject_field"
        :qid="`${currentQuestion.work_id}-${currentQuestion.id}`"
        :uid="`user ${accountStore.userId}`" 
        :workname="workStore.selectedWork[workStore.selectedWorkIndex].name"
        :qcode="currentQuestion.code"
        :ucid="`${accountStore.studentProfile.profile.classroom.id}`"
        :usid="`${accountStore.studentProfile.profile.school.id}`"
        @close="reportModal=false" 
        @close-layer="reportModal=false">
      </error-report-modal>
      <!--final result modal-->
      <full-screen-modal v-model="finalModal">
        <template #main>
          <div :class="{'c-popup-body__resultBox': true, [`-star${result.number_of_stars}`]:true }">
            <div class="c-popup-body__resultBox-inner">
              <div class="box -star" v-if="!workStore.isReviewQuestion">
                <div class="box__head">獲得スター</div>
                <div class="box__detail">
                  <three-stars :number-of-stars="result.number_of_stars" :full-screen="true" :active-stars="activeStars"></three-stars>
                </div>
              </div>
              <div class="box -correct">
                <div class="box__head">正答数</div>
                <div class="box__detail" v-if="workStore.isUnanswered">
                  <span class="label"><span class="num">{{ totalNumberOfCorrectAnswer }}</span><span class="unit unit--Q">問</span></span><span class="count">/全<span class="num">{{ workStore.totalNumOfQuestion }}</span>問中</span>
                </div>
                <div class="box__detail" v-else>
                  <span class="label"><span class="num">{{ numberOfCorrectAnswer }}</span><span class="unit unit--Q">問</span></span><span class="count">/全<span class="num">{{ workStore.totalNumOfQuestion }}</span>問中</span>
                </div>
              </div>
            </div>
            <div class="box -main">
              <div class="c-popup-body__resultBox-wrapper">
                <div class="c-popup-body__resultBox-graph">
                  <p class="box__head">正答率</p>
                  <div class="c-graph-speechBubble" :style="{animationDelay: `calc((0.02s*${result.correct_answer_rate}) + 0.18s)`}" v-if="workStore.isUnanswered && !workStore.isReviewQuestion">
                    <div class="c-graph-speechBubble__inner" :style="{left: `calc(${result.correct_answer_rate}% - 59px)`}">
                      <div class="label">前回から<span class="graph-num">+{{result.correct_answer_rate - result.correct_answer_rate_previous}}</span><span class="graph-unit">%</span></div>
                      <div class="c-graph-speechBubble__arrow"></div>
                    </div>
                  </div>
                  <div class="c-graph" v-if="!workStore.isReviewQuestion">
                    <three-stars :number-of-stars="result.number_of_stars" :is-graph="true" :active-stars="activeStars"></three-stars>
                    <figure-bar-horizontal :percentage="result.correct_answer_rate" :is-active="activeStars"></figure-bar-horizontal>
                  </div>
                  <div class="c-graph" v-else>
                    <figure-bar-horizontal :percentage="correctAnswerRate" :is-active="activeStars" :is-review="workStore.isReviewQuestion"></figure-bar-horizontal>
                  </div>
                  <div class="c-popup-body__resultBox-comment" :style="{animationDelay: `calc((0.02s* ${result.correct_answer_rate}) + 0.8s)`}" v-if="!(workStore.isReviewQuestion || result.number_of_stars === 3)">
                    <template v-if="result.number_of_stars === 1">
                      <div class="c-popup-body__resultBox-comment-text">
                        <span>あと{{remainingQuestionsToGetTwoStar}}問正解で</span>
                        <img src="@/styles/img/common/icon_rate_star_active.svg" width="16" height="16">
                        <span>2つ獲得だよ！</span>
                      </div>
                      <div class="c-popup-body__resultBox-comment-text">
                        <span>全問正解で</span>
                        <img src="@/styles/img/common/icon_rate_star_active.svg" width="16" height="16">
                        <span>3つ獲得だよ！</span>
                      </div> 
                    </template>
                    <template v-else-if="result.number_of_stars === 2">
                      <div class="c-popup-body__resultBox-comment-text">
                        <span>あと{{remainingQuestionsToGetThreeStar}}問正解で</span>
                        <div class="c-popup-body__resultBox-comment-text">
                          <img src="@/styles/img/common/icon_rate_star_active.svg" width="16" height="16">
                          <span>3つ獲得だよ！</span>  
                        </div>
                      </div>
                    </template>                           
                  </div>
                </div>
                <div class="c-popup-body__resultBox-button">
                  <button-blue v-if="getUnsolvedQuestion.length > 0" :medium="true" :large="true" @click="solveWrongAnswerOnly()" :tab-index="tabIndex" name="S3-10-unanswered-question-btn">間違えた問題だけ再チャレンジ</button-blue>
                </div>
                <div class="c-parts-homework-information" v-if="homeworkInfo.length != 0">
                  <div class="c-parts-homework-information-item" v-for="homework in homeworkInfo">
                    <div class="c-parts-homework-information-label">宿題</div>
                    <div class="c-parts-homework-information-limit"><span>{{ homework.month }}</span>月<span>{{ homework.day }}</span>日({{ homework.dayOfWeek }}) <span>{{ homework.time }}</span>まで</div>
                    <div class="c-parts-homework-information-status">
                      <div class="c-parts-homework-status" :class="{[homework.statusClass]: true}">{{ homework.status }}</div>
                      <div class="c-parts-pin">{{ homework.achievement }}</div>
                      <div class="c-parts-pin -row" v-if="homework.relearning">{{ homework.relearning }}</div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <!-- <div class="c-popup-body__resultBox-under-button">
              <a href="" class="c-button-white -pen -small">
                <span class="label">
                  補充問題を学習
                </span>
              </a>  
            </div> -->
          </div>
        </template>
        <template #footer>
          <div class="c-button -end" v-if="workStore.isMissionQuestion">
            <button-arrow-right @click="closeModal('finalResult')" :medium="true" :right="true" :tab-index="tabIndex" name="S3-10-finish-btn">
              ミッション一覧へ
            </button-arrow-right>
          </div>
          <div class="c-button -end" v-else>
            <button-white @click="closeModal('finalResult')" :no-icon="true" :medium="true" name="S3-10-finish-btn">
              終わる
            </button-white>
            <button-arrow-right @click="goNextQuestionSet()" :medium="true" :right="true" :tab-index="tabIndex" name="S3-10-next-question-btn" v-if="!!workStore.nextQuestionSet  && !workStore.isReviewQuestion && (learningStartPageName === 'work' || learningStartPageName ==='chapter')">
              次の問題へ
            </button-arrow-right>
            <button-arrow-right :medium="true" :right="true" @click="solveRemainingProblems()" :tab-index="tabIndex" name="S3-10-remaining-question-btn" v-if="isSolveRemainingProblems">
              次の{{numberOfRemainingQuestion}}問へ
            </button-arrow-right>
          </div>
        </template>
      </full-screen-modal>
    </main>
  </div>
</template>

<script setup lang="ts">
  import {ref, computed, onMounted, onUnmounted, nextTick, watch} from 'vue';
  import {useRoute, useRouter} from "vue-router";
  import {event} from "vue-gtag";
  import confetti from "canvas-confetti"
  import * as Sentry from "@sentry/browser";
  import {CHOICESLABEL} from "@/consts/choicesLabel";
  import {QUIZTYPE, GRADINGMETHOD, LAYOUT, QUIZTYPE_NAME} from '@/consts/answer_column';
  import {STUDY_TARGET_KIND, REVIEW_REQUIRED} from "@/consts/study";
  import {MISSIONKIND_SORT} from "@/consts/mission";
  import AudioPlayer from '@/consts/sounds';
  import remove_markdown from "@/util/remove_markdown";
  import redirect_error_page from "@/util/redirect_error_page";
  import { isEnvCaptureGoogleAnalyticsEvents } from "@/util/env"
  import hideMiniContextMenuOnEdge from "@/util/diabled-context-menu"
  import { nestedItems } from '@/util/collect-nested-data';
  import {DISABLED_BUTTON_TIME, FOCUS_DELAY_TIME, MAX_TRANSITION_TIME} from "@/consts/study"
  import {IHomeworkQuestionSet} from "@/consts/interfaces";
  import HomeworkInfo from "@/util/homework-info";
  import { useWorkStore } from '@/store/student/work_store';
  import { useGlobalNavigationStore } from '@/store/student/global_navigation_store'; 
  import { useAccountStore } from '@/store/student/account_store';
  import { useTopStore } from '@/store/student/top_store';
  import { useHomeworkStore } from '@/store/student/homework_store';
  import local_time from "@/util/datetime";
  import getCsrfTokenFromCookie from "@/util/csrf-token";
  import { saveInitialStudyBreakData } from '@/util/study_break_data';
  import { getLatestBreakDataVersion } from '@/consts/break_data_version'
  import { createLatestQuestionHistories } from '@/util/create-lastest-qhistories';

  interface IResult{
    question_set_history_ids: Array<number>,
    number_of_stars: number | null,
    correct_answer_rate: number | null,
    correct_answer_rate_previous: number | null,
    homework_info: Array<IHomeworkQuestionSet>,
  }
  const audioPlayer = AudioPlayer.getInstance()
  const route = useRoute()
  const router = useRouter()
  const workStore = useWorkStore()
  const globalNavigationStore = useGlobalNavigationStore()
  const accountStore = useAccountStore()
  const topStore = useTopStore()
  const homeworkStore = useHomeworkStore()
  const refModQuestionInner = ref(null)
  const refModQuestionBody = ref(null)
  const refQuestionBody = ref(null)
  const refAnswerExplanation = ref(null)
  const processing = ref(false)
  const stopQAModal = ref(false)
  const skillModal = ref(false)
  const finalModal = ref(false)
  const hintModal = ref(false)
  const pointModal = ref(false)
  const reportModal = ref(false)
  const totalNumberOfCorrectAnswer = ref(0)
  const result = ref<IResult>({
    question_set_history_ids: [],
    number_of_stars: 0,
    correct_answer_rate: 0,
    correct_answer_rate_previous: 0,
    homework_info: []
  })
  const correctAnswerRate = ref(0)
  const isSolveRemainingProblems = ref(false)
  const numberOfRemainingQuestion = ref(0)
  const tabIndex = ref(0)
  const homeworkInfo = ref([])
  const missionKind = MISSIONKIND_SORT
  // copy store question_index to local variable
  const qIndex = ref(workStore.questionIndex)
  const activeStars = ref(false)
  const subject_field = workStore.selectedWork[workStore.selectedWorkIndex].subject_field
  const learningStartPage = workStore.learningStartPage
  // NFR-5158: make a constant of learning start page router name and params
  const learningStartPageName = learningStartPage?.name
  const learningStartPageParams = learningStartPage?.params
  const selectedQuestionSet = workStore.selectedQuestionSet
  onMounted(async() => {
    // 内側のスクロール動きのため外側(body)スクロールを禁止する（ipadの不具合）
    let body_tag = document.getElementsByTagName('body')[0]
    body_tag.classList.add("unscrollable")
    if(accountStore.isDebug){
      accountStore.saveDebugSouruby(true)
    }
    else{
      accountStore.saveDebugSouruby(accountStore.isSouruby)
    }
    window.addEventListener('pagehide', onPageHide, false);
    window.history.pushState({}, null, null);
    window.addEventListener('popstate', browserBackHandler)
    window.addEventListener('resize', questionBodyHeight)
    setDocumentTitle()

    // if all question is skip then goto S3-10 page
    if(route.query.p === 'skip') {
      // correction of correct answer if skip next button press from last question
      totalNumberOfCorrectAnswer.value = numberOfCorrectAnswer.value + preNumberOfCorrectAnswer.value
      await openModal("finalResult")
      // after show final modal mounted stop here
      return
    }
    if(workStore.transitTime > 0){
      const time_diff = Date.now() - workStore.transitTime
      if(time_diff > MAX_TRANSITION_TIME) {
        // after throw this event custom context automatically deleted
        // https://docs.sentry.io/platforms/javascript/guides/vue/enriching-events/scopes/#local-scopes
        Sentry.withScope(function(scope) {
          scope.setContext("Transition Information", {
            name: "Answer",
            duration: `${time_diff} ms`,
            question_id: workStore.questions[qIndex.value].id,
            work_id: workStore.questions[qIndex.value].work_id,
          });
          scope.setLevel("warning");
          Sentry.captureMessage("画面遷移で5秒以上かかる");
        });
      }
      // reset transit time start
      workStore.saveTransitTime(0)
    }
    nextTick(() => {
      setTimeout(() => {
        // NFR-3683 非活性されたボタンを500ミリ秒以降に活性化する
        workStore.saveIsDisabledButton(false)
        // NFR-3772 対応
        setTimeout(()=>{
          focusFirstElement(1)
        },FOCUS_DELAY_TIME)
      }, DISABLED_BUTTON_TIME)
    })
  })
  onUnmounted(() => {
    window.removeEventListener('pagehide', onPageHide, false)
    window.removeEventListener('popstate', browserBackHandler, false)
    window.removeEventListener('resize', questionBodyHeight, false)
  })
  function resolvePrevious(){
    let index: number = 0
    for(let i=workStore.questionCorrectWrongList.length - 1; i>=0; i--){
      if(workStore.questionCorrectWrongList[i].progress == 1){
        index = i
        break
      }
    }
    workStore.saveResolvedQuestionCorrectWrong(index)
    workStore.saveResolvedInitialAnswer(index)
    workStore.saveQIdx(index)
    router.push({name:'question'}).catch(() => {})
  }
  // NFR-5990: make a computed property for current question so every changes in question index will reflect in current question
  const currentQuestion = computed(() => {
    // if question is loaded and current question is present then return the current question
    if (workStore.questions.length > 0 && qIndex.value < workStore.questions.length) {
      return workStore.questions[qIndex.value];
    }
    // if question is not loaded or current question is not present then return null
    return null;
  });
  const isJapanese = computed(() => {
    return subject_field === '国語'
  })
  const isScience = computed(() => {
    return subject_field === '理科'
  })
  const isKeyboard = computed(() => {
    return subject_field === '理科' || subject_field === '数学'
  })
  const selectedWorkId = workStore.selectedWork[workStore.selectedWorkIndex]?.id
  const numberOfCorrectAnswer = computed(() => {
    return workStore.questionCorrectWrongList.filter(item => item.result==true).length
  })
  const preNumberOfCorrectAnswer = computed(() => {
    return workStore.totalNumOfQuestion - workStore.questions.length
  })
  const remainingQuestionsToGetTwoStar = computed(() => {
    let mid = Math.ceil(workStore.totalNumOfQuestion/2)
    if(workStore.isUnanswered){
      return mid - totalNumberOfCorrectAnswer.value
    }
    return mid - numberOfCorrectAnswer.value
  })
  const remainingQuestionsToGetThreeStar = computed(() => {
    if(workStore.isUnanswered){
      return workStore.totalNumOfQuestion - totalNumberOfCorrectAnswer.value
    }
    return workStore.totalNumOfQuestion - numberOfCorrectAnswer.value
  })
  const selectedQuestionSetTitle = computed(() => {
    if(workStore.isSearchQuestionById){
      for(let section of workStore.sections){
        if(section.id==workStore.questions[qIndex.value].section_id){
          for(let question_set of section.question_sets){
            if(question_set.id == workStore.questions[qIndex.value].question_set_id){
              return question_set.title
            }
          }
        }
      }
      return ""
    }
    // NFR-3031, Optional chaining operator (?.) to avoid Undefined cannot access property <property_name>
    return selectedQuestionSet[workStore.questions[qIndex.value]?.question_set_id]?.title || ""
  })
  const selectedQuestionPageRange = computed(() => {
    // NFR-5754: save the current learning question
    const selectedQuestion = workStore.questions[qIndex.value]
    if(selectedQuestion){
      if(selectedQuestion.textbook_startpage === '0' || selectedQuestion.textbook_endpage === '0'){
        return ''
      } 
      else if(selectedQuestion.textbook_startpage === selectedQuestion.textbook_endpage){
        return selectedQuestion.textbook_startpage;
      } 
      else {
        return `${selectedQuestion.textbook_startpage}-${selectedQuestion.textbook_endpage}`
      }
    } else {
      return ''
    }
  })
  const getQuestionLabels = computed(() => {
    // NFR-5867: if question is loaded and current question is present then return the question labels
    if(workStore.questions.length > 0 && workStore.questions[qIndex.value]){
      return workStore.questions[qIndex.value].question_labels.map(item => item.name)
    } else {
      return []
    }
  })
  const getReviewTag = computed(() => {
    let tag = workStore.reviewTags.filter(item =>
        item.question.id == workStore.questions[qIndex.value].id
    )
    return tag.length > 0;
  })
  const getTagCorrect = computed(() => {
    const question = workStore.questions[qIndex.value]
    if(question){
      let is_correct = workStore.questionProgress[question.id]
      if(!!is_correct){
        return is_correct.is_done_correctly
      }
      else{
        return false
      }
    }
    else{
      return false
    }
  })
  const isAutoGrading = computed(() => {
    return !(
      workStore.questions[qIndex.value].quizzes.length == 1 &&
      workStore.questions[qIndex.value].quizzes[0].grading_format == GRADINGMETHOD.MANUAL
    )
  })
  const getExplanationAnswer = computed(() => {
    // to check a pattern that enclosed with # half or full width
    const pattern = /^(#|＃)(.*?)(#|＃)$/g
    let explanationAnswer = []
    let quizzes: Array<any> = workStore.questions[qIndex.value].quizzes
    for(let quiz of quizzes){
      if(quiz.answer_format == QUIZTYPE.DESCRIPTION){
        // delete empty "" answer
        let answers: Array<string> = quiz.body.answers.filter(item => item)
        let len: number = answers.length
        let answer: string = ""
        if(len!=0 && quiz.grading_format==GRADINGMETHOD.AUTOMATIC){
          formatQuizAnswer(quiz, answers)
          answer += answers[0]
          let other_answer: string = ''
          if(accountStore.isDebug) {
            // add （生徒には非表示）if answer enclosed with hash(#)
            other_answer = answers.slice(1).map(word => word.replace(pattern, '$2（生徒には非表示）')).join(' ／ ')
          }else {
            // collect other answers and omit hash(#) enclosed answers
            other_answer = answers.slice(1).map(word => word.replace(pattern, '')).filter(text => text.length).join(' ／ ')
          }
          if(other_answer.length){
            answer = `${answer}（別解：${other_answer}）`
          }
        }else{
          answer += formatQuizAnswer(quiz, [quiz.body.exampleAnswer])
        }
        explanationAnswer.push(
          {
            label: quiz.label,
            answers: [answer],
            gradingHint: quiz.body.gradingHint,
            isHalf: quiz.display_options.textInputFormat === LAYOUT.HALF,
            isMulti: quiz.display_options.textInputFormat === LAYOUT.MULTI,
            prefix: quiz.body.prefix,
            suffix: quiz.body.suffix
          }
        )
      }
      else if(quiz.answer_format == QUIZTYPE.SELECT || quiz.answer_format == QUIZTYPE.MULTIPLE_CHOICE_RANDOM_ORDER){
        let answers = quiz.body.answers.map((item, index) => {
            return quiz.display_options.choicesLabel === 1 ? item : {answerText: CHOICESLABEL[quiz.display_options.choicesLabel][index], isCorrectAnswer: item.isCorrectAnswer}
        })
        explanationAnswer.push(
          {
            label: quiz.label,
            answers: answers.filter(item=> item.isCorrectAnswer).map(item => item.answerText),
            isHalf: quiz.display_options.choicesLayout === LAYOUT.HALF,
          }
        )
      }
      else if(quiz.answer_format == QUIZTYPE.SORTING){
        let item = quiz.body.answers.map((i, index) => {
            return quiz.display_options.choicesLabel === 1 ? i : {answerText: CHOICESLABEL[quiz.display_options.choicesLabel][index], answerOrder: i.answerOrder}
        }).filter(v=>v.answerOrder > 0)
        let answer = item.sort(function(a, b){return a.answerOrder - b.answerOrder}).map(i=> i.answerText).join(isJapanese.value?'⇓':'⇒')
        explanationAnswer.push(
          {
            label: quiz.label,
            answers: [answer],
            isHalf: quiz.display_options.choicesLayout === LAYOUT.HALF,
          }
        )
      }else if(quiz.answer_format == QUIZTYPE.NO_ANSWER){
        explanationAnswer.push(
          {
            label: quiz.label,
            answers: [quiz.body.exampleAnswer],
            gradingHint: quiz.body.gradingHint,
            isHalf: quiz.display_options.textInputFormat === LAYOUT.HALF,
            isMulti: quiz.display_options.textInputFormat === LAYOUT.MULTI,
            prefix: quiz.body.prefix,
            suffix: quiz.body.suffix
          }
        )
      }
      else if(quiz.answer_format == QUIZTYPE.WRITTEN_RANDOM_ORDER){
        let answers: Array<string> = []
        for(let answerList of quiz.body.answersList){
          let answer: string = ""
          answerList = answerList.filter(item => item) // remove empty item
          formatQuizAnswer(quiz, answerList)
          let len: number = answerList.length
          if(len > 0){
            answer += answerList[0]
            let other_answer: string = ''
            if(accountStore.isDebug) {
              // add （生徒には非表示）if answer enclosed with hash(#)
              other_answer = answerList.slice(1).map(word => word.replace(pattern, '$2（生徒には非表示）')).join(' ／ ')
            }else {
              // collect other answers and omit hash(#) enclosed answers
              other_answer = answerList.slice(1).map(word => word.replace(pattern, '')).filter(text => text.length).join(' ／ ')
            }
            if(other_answer.length){
              answer = `${answer}（別解：${other_answer}）`
            }
          }
          answers.push(answer)
        }
        explanationAnswer.push(
          {
            label: quiz.body.answersLabel? quiz.body.answersLabel || []: [],
            answers: answers,
            gradingHint: quiz.body.gradingHint,
            isHalf: quiz.display_options.textInputFormat === LAYOUT.HALF,
            isMulti: quiz.display_options.textInputFormat === LAYOUT.MULTI,
            prefix: quiz.body.prefix,
            suffix: quiz.body.suffix,
            isRandomAnswer: QUIZTYPE.WRITTEN_RANDOM_ORDER
          }
        )
      }
    }
    return explanationAnswer
  })
  const answerVerify = computed(() => {
    //  [{text: 'Newton', isCorrectAnswer: true, isHalf: true, prefix: '', suffix: ''}]
    let answer: { text: string, isCorrectAnswer: boolean, isHalf: boolean, isMulti: boolean, prefix: string, suffix: string, label: string, answers?: Array<any>, isInput: boolean, isNoAnswer: boolean, isDeleted: boolean }[] = []
    let quizzes = workStore.questions[qIndex.value].quizzes;
    if (subject_field === '英語') {
      let idx = 0
      for (let quiz of workStore.initialAnswer[qIndex.value].quiz_histories) {
        if (quizzes[idx]) { // NFR-4057 TODO: スキップが根本的な解決ではないのでコードリファクタリングで原因探すのが必要
          if (quiz.sub_quizzes) {
            // for access random written quiz label
            let sub_quiz_idx = 0
            for (let sub_quiz of quiz.sub_quizzes) {
              answer.push({
                text: sub_quiz.answer,
                isCorrectAnswer: sub_quiz.is_correct_answer,
                isHalf: quizzes[idx].display_options.textInputFormat === LAYOUT.HALF || quizzes[idx].display_options.choicesLayout === LAYOUT.HALF,
                isMulti: quizzes[idx].display_options.textInputFormat === LAYOUT.MULTI,
                prefix: quizzes[idx].body.prefix || '',
                suffix: quizzes[idx].body.suffix || '',
                label: quizzes[idx].body.answersLabel? quizzes[idx].body.answersLabel[sub_quiz_idx] || '': '',
                answers: quizzes[idx].body.answers,
                isInput: quizzes[idx].answer_format === QUIZTYPE.DESCRIPTION,
                isNoAnswer: quizzes[idx].answer_format === QUIZTYPE.NO_ANSWER,
                isDeleted: sub_quiz.is_deleted || false,
              })
              sub_quiz_idx++
            }
          } else {
            answer.push({
              text: formatUserAnswer(quizzes[idx], quiz.answer),
              isCorrectAnswer: quiz.is_correct_answer,
              isHalf: quizzes[idx].display_options.textInputFormat === LAYOUT.HALF || quizzes[idx].display_options.choicesLayout === LAYOUT.HALF,
              isMulti: quizzes[idx].display_options.textInputFormat === LAYOUT.MULTI,
              prefix: quizzes[idx].body.prefix || '',
              suffix: quizzes[idx].body.suffix || '',
              label: quizzes[idx].label || '',
              answers: quizzes[idx].body.answers,
              isInput: quizzes[idx].answer_format === QUIZTYPE.DESCRIPTION,
              isNoAnswer: quizzes[idx].answer_format === QUIZTYPE.NO_ANSWER,
              isDeleted: quiz.is_deleted || false,
            })
          }
        }
        idx++
      }
    } else {
      let idx = 0
      for (let quiz of workStore.initialAnswer[qIndex.value].quiz_histories) {
        if (quizzes[idx]) { // NFR-4057
          if (quiz.sub_quizzes) {
            // for access random written quiz label
            let sub_quiz_idx = 0
            for (let sub_quiz of quiz.sub_quizzes) {
              answer.push({
                text: formatUserAnswer(quizzes[idx], sub_quiz.answer),
                isCorrectAnswer: sub_quiz.is_correct_answer,
                isHalf: quizzes[idx].display_options.textInputFormat === LAYOUT.HALF || quizzes[idx].display_options.choicesLayout === LAYOUT.HALF,
                isMulti: quizzes[idx].display_options.textInputFormat === LAYOUT.MULTI,
                prefix: quizzes[idx].body.prefix || '',
                suffix: quizzes[idx].body.suffix || '',
                label: quizzes[idx].body.answersLabel? quizzes[idx].body.answersLabel[sub_quiz_idx] || '': '',
                isNoAnswer: quizzes[idx].answer_format === QUIZTYPE.NO_ANSWER,
                isDeleted: sub_quiz.is_deleted || false,
                isInput: quizzes[idx].answer_format === QUIZTYPE.DESCRIPTION || quizzes[idx].answer_format === QUIZTYPE.WRITTEN_RANDOM_ORDER,
              })
              sub_quiz_idx++
            }
          }
          else {
            answer.push({
              text: formatUserAnswer(quizzes[idx], quiz.answer),
              isCorrectAnswer: quiz.is_correct_answer,
              isHalf: quizzes[idx].display_options.textInputFormat === LAYOUT.HALF || quizzes[idx].display_options.choicesLayout === LAYOUT.HALF,
              isMulti: quizzes[idx].display_options.textInputFormat === LAYOUT.MULTI,
              prefix: quizzes[idx].body.prefix || '',
              suffix: quizzes[idx].body.suffix || '',
              label: quizzes[idx].label || '',
              isNoAnswer: quizzes[idx].answer_format === QUIZTYPE.NO_ANSWER,
              isDeleted: quiz.is_deleted || false,
              isInput: quizzes[idx].answer_format === QUIZTYPE.DESCRIPTION || quizzes[idx].answer_format === QUIZTYPE.WRITTEN_RANDOM_ORDER,
            })
          }
        }
        idx++
      }
    }
    return answer
  })
  const getAnswerButtonText = computed(() => {
    return workStore.questionIds.length > qIndex.value + 1 ? '次の問題へ' : '解答結果へ進む'
  })
  const remainingQuestions = computed(() => {
    return workStore.remainQuestion.length
  })
  const getUnsolvedQuestion = computed(() => {
    let questions: Array<any> = []
    for(let i in workStore.initialAnswer){
      if(!workStore.initialAnswer[i].is_correct_answer && workStore.questions[i]){
        let question: any = JSON.parse(JSON.stringify(workStore.questions[i]))
        questions.push(question)
      }
    }
    return questions
  })
  const getCheckFormulaAsString = computed(() => {
    return workStore.questions[qIndex.value].quizzes.filter(quiz =>{
      return quiz.answer_format === QUIZTYPE.DESCRIPTION || quiz.answer_format == QUIZTYPE.WRITTEN_RANDOM_ORDER
    })
  })
  const getAnswerFormat = computed(() => {
    return workStore.questions[qIndex.value].quizzes.map(quiz =>{
      return {
        label: quiz.label,
        answer_format: QUIZTYPE_NAME[quiz.answer_format]
      }
    })
  })
  const abortStudyLog = (action: string) => {
    const logData = {
      "abort_action" : action,
      "work_id" : selectedWorkId,
      "question_code": workStore.questions[qIndex.value]?.code || null,
      "question_start_datetime": workStore.start_date,
      "question_abort_datetime": local_time()
    }
    const jsonData = {
      'token' : getCsrfTokenFromCookie(document.cookie),
      'log' : logData
    }
    const headers = {
      type: 'application/json',
    };
    const blob = new Blob([JSON.stringify(jsonData)], headers);
    return blob
  }
  function getPoint(section_id){
    let section = workStore.sections.filter(item => item.id == section_id)
    if(section.length>0){
      return section[0].point
    }
    else{
      return ""
    }
  }
  // 理科の場合、アルファベットは正体にする必要があるので別にフォーマットを変更する
  function formatQuizAnswer(quiz, answers){
    if (isScience.value) {
      if (quiz.answer_format === QUIZTYPE.DESCRIPTION || quiz.answer_format === QUIZTYPE.WRITTEN_RANDOM_ORDER) { // 記述式または順不問記述式の場合
        for (let i = 0; i < answers.length; i++) {
          if (!answers[i].includes("\\ce")) { // \\ceコマンドを使うとアルファベットが正体になるので除外する
            answers[i] = answers[i].replaceAll(/[\$](\\|[0-9]*)([A-Za-z])/g, "$\\rm $1$2")
          }
        }
      }
    }
    return answers
  }
  // ユーザー解答のフォーマット変更
  function formatUserAnswer(quiz, answer){
    if(quiz.answer_format == QUIZTYPE.SORTING && quiz.display_options.choicesLabel !== 1){
      let new_answer = answer.split(isJapanese.value?'⇓':'⇒')
      return new_answer.map(item => CHOICESLABEL[quiz.display_options.choicesLabel][quiz.body.answers.map(i => i.answerText).indexOf(item)]).join(isJapanese.value?'⇓':'⇒')
    }
    if(isScience.value){ // 理科の場合、アルファベットは正体にする必要があるので別にフォーマットを変更する
      if(quiz.answer_format == QUIZTYPE.DESCRIPTION || quiz.answer_format == QUIZTYPE.WRITTEN_RANDOM_ORDER){
        // NFR-4637 物理キーボードで化学式を直接に入力する時プラス記号の前後にスペースを入れる。
        answer = answer.replaceAll(/([0-9A-Za-z\+\-\}])(\+)/g, '$1 $2 ')
        answer = answer.replaceAll(/[\$](\\|[0-9]*)([A-Za-z])/g, "$\\rm $1$2")
      }
    }
    return answer
  }
  function allSkills(){
    return workStore.questions[qIndex.value].skills.map(item => item.name).join(', ')
  }
  function toggleRubySwitch(){
    accountStore.saveDebugSouruby(!accountStore.isDebugSouruby)
  }
  function onPageHide(evt: Event): void {
    // NFR-5116: swap study break data
    workStore.swapStudyBreakData('answer')
    const question = workStore.questions[qIndex.value]
    if(isEnvCaptureGoogleAnalyticsEvents()){
      navigator.sendBeacon('/student/api/log/abort_study', abortStudyLog("window_unload"));
      event('abort_study', {
        'work_id': selectedWorkId,
        'subject_field': subject_field,
        'question_id': question?.id,
        'question_index': qIndex.value + 1,
        'screen_code': route.meta.screenCode,
        'abort_action': "window_unload"
      })
    }
  }
  function browserBackHandler(evt: PopStateEvent): void{
    window.history.pushState({}, null, null);
    stopQAModal.value = true
  }
  async function openModal(modal){
    if(modal == 'hint'){
      hintModal.value = true
      if(isEnvCaptureGoogleAnalyticsEvents()){
        event('show_hint', {
          'work_id': selectedWorkId,
          'question_id': workStore.questions[qIndex.value].id,
          'question_index': qIndex.value + 1
        })
      }
    }
    else if(modal == 'point'){
      pointModal.value = true
      if(isEnvCaptureGoogleAnalyticsEvents()){
        event('show_quesion_point', {
          'work_id': selectedWorkId,
          'question_id': workStore.questions[qIndex.value].id,
          'question_index': qIndex.value + 1
        })
      }
    }
    else if(modal == 'finalResult'){
      // collect existence mission for selected question_set
      let mission_exist:any = null
      // NFR-5240 workStore.selectedQuestionSetをローカル変数に格納して利用＆存在チェックする。
      if(selectedQuestionSet && Object.keys(selectedQuestionSet).length == 1 && !workStore.isMissionQuestion){
        // NFR-5991: Initialize a variable to get question_set_id
        const question_set_id = Number(Object.keys(selectedQuestionSet)[0]);
        // NFR-5991: question_set_idが存在する場合、ミッションが存在するか確認する。
        if (question_set_id){
          for(let subject_mission of topStore.missions.subject_field_missions){
            for(let mission of subject_mission.missions){
              if(mission && mission.question_set.id == question_set_id){
                mission_exist = {uuid: mission.uuid, kind: mission.mission_kind}
                break
              }
            }
            if(mission_exist != null){
              break
            }
          }
        }
      }
      // reset next_question_set
      workStore.saveNextQuestionSet(null)
      workStore.fetchSaveStudyResult()
          .then(async (response) => {
              // NFR-5249 responseが存在しない場合、処理を中断
              if(!response){
                return;
              }
              result.value = response.data
              if(accountStore.isSoundEnabled){
                audioPlayer.backGroundSound().play()
                audioPlayer.starSound().play()
              }
              homeworkInfo.value = []
              activeStars.value = true
              if(!workStore.isMissionQuestion){
                let work_id: number = workStore.selectedWork[workStore.selectedWorkIndex].id
                workStore.fetchNextQuestionSet({"work_id": work_id})
              }
              // 「まとめて問題を解く」要復習問題の場合
              if(workStore.isReviewQuestion){
                // 「まとめて問題を解く」要復習問題かつ残り問題がある場合、「次の〇〇問へ」ボタンを表示
                if(remainingQuestions.value > 0){
                  isSolveRemainingProblems.value = true
                  numberOfRemainingQuestion.value = remainingQuestions.value
                }
                if(workStore.isUnanswered){ // 「未正解の問題だけ学習」押して解いた時
                  let correct_answer:number = numberOfCorrectAnswer.value + preNumberOfCorrectAnswer.value
                  correctAnswerRate.value = Math.floor(correct_answer / workStore.totalNumOfQuestion * 100)
                }else{
                  correctAnswerRate.value = Math.floor(numberOfCorrectAnswer.value / workStore.totalNumOfQuestion * 100)
                }
              } else{ // 「まとめて問題を解く」要復習問題以外の問題
                correctAnswerRate.value = result.value.correct_answer_rate
              }
              // save_result apiのhomework_infoレスポンスがあるかつ「まとめて解く」と「ミッション」ではない場合、宿題情報設定
              if(result.value.homework_info.length != 0 && !workStore.isReviewQuestion && !workStore.isMissionQuestion){
                // 宿題期限が近い順にソートして渡す。
                result.value.homework_info.sort(function(a,b) {return new Date(a.end_datetime).getTime() - new Date(b.end_datetime).getTime()})
                const hwInfo = new HomeworkInfo(null,result.value.homework_info)
                homeworkInfo.value = hwInfo.info
              }
              finalModal.value = true
              if(result.value.number_of_stars === 3){
                setTimeout(() => startConfettiAnimation(), 1600) // 1600ミリ秒後に実行
              }
              // delete study break data after finish learning
              workStore.deleteStudyBreakData()
              // reload mission if exist in mission card
              if(mission_exist != null){
                await topStore.fetchGenerateMissionList({recreate: mission_exist.uuid})
                let question_set_ids = nestedItems(topStore.missions, "subject_field_missions[].missions[].question_set.id")
                if(question_set_ids.length > 0){
                  topStore.saveQuestionSetIds(question_set_ids)
                  await topStore.fetchLatestQuestionSetHistories({'question_set_ids': question_set_ids})
                  await topStore.fetchMissionQuestionSetProgress({'question_set_ids': question_set_ids})
                }
              }
              // after learn subject recommendation may be change
              await topStore.fetchRecommendedSubjects()
              // 更新された宿題出題単位状態を画面に反映する。
              await homeworkStore.fetchHomeworkQuestionSet()
              processing.value = false
              workStore.saveIsDisabledButton(false)
              // NFR-5698 account/status apiが複数回呼ばれる現象を防ぐため、学習結果表示後に呼ばれるように変更
              if(!workStore.isMissionQuestion){
                await globalNavigationStore.fetchNavAccountStatus(null)
              }
          })
          .catch(e => {
              redirect_error_page(e)
          })
    }
  }
  function closeModal(modal){
    if(modal=='stopAQModal'){
      // setting study end time for current question
      workStore.saveQuestionStudyEndTime()
      // NFR-5116: swap study break data
      workStore.swapStudyBreakData('answer')
      workStore.saveIsMissionQuestion(false)
      workStore.saveIsPrevQuestionHistory(false)
      homeworkStore.saveIsHomework(false)
      workStore.saveIsLearningPage(false)
      if(accountStore.isSoundEnabled){audioPlayer.closeSound().play()}
      if(isEnvCaptureGoogleAnalyticsEvents() && !workStore.isPrevQuestionHistory){
        navigator.sendBeacon('/student/api/log/abort_study', abortStudyLog("abort_button_click"));
        event('abort_study', {
          'work_id': selectedWorkId,
          'subject_field': subject_field,
          'question_id': workStore.questions[qIndex.value].id,
          'question_index': qIndex.value + 1,
          'screen_code': route.meta.screenCode,
          'abort_action': "abort_button_click"
        })
      }
      router.push({path:!!workStore.learningStartPage?workStore.learningStartPage.path:'/student/'}).then(async() => {
        workStore.saveIsSearchQuestionById(false)
        workStore.saveIsLearningMode(false)
        }
      )
    }
    else if(modal == 'finalResult'){
      if(accountStore.isSoundEnabled){audioPlayer.endSound().play();}
      audioPlayer.backGroundSound().stop()
      workStore.saveIsLearningPage(false)
      // NFR-5456: save last learned question_set_id
      if(!workStore.isReviewQuestion && !workStore.isMissionQuestion && !homeworkStore.isHomework) {
        workStore.saveLastLearningQuestionSetId(workStore.questions[qIndex.value].question_set_id)
      }
      router.push({path:!!workStore.learningStartPage?workStore.learningStartPage.path:'top'}).then(()=> workStore.saveIsLearningMode(false))
    }
    else if(modal == 'hint'){
      hintModal.value = false
    }
    else if(modal == 'point'){
      pointModal.value = false
    }
  }
  function toggleReviewTag(){
    let enabled = !getReviewTag.value
    workStore.fetchUpdateReviewTag(
      {question_id: workStore.questions[qIndex.value].id, enabled: enabled}
    )
  }
  async function nextQuestion(){
    if(processing.value == true){
      return
    }
    processing.value = true
    workStore.saveIsDisabledButton(true)
    // if current question is the last question
    if(workStore.questionIds.length == qIndex.value+1){
      // if all question are skip then return to learning start page
      let skipAll = workStore.questionCorrectWrongList.every(item => item.progress==1 && item.result==null)
      // if is latest history then go to learning start page
      if(workStore.isPrevQuestionHistory){
        workStore.saveIsDisabledButton(false)
        workStore.saveIsLearningPage(false)
        if(workStore.learningStartPage!=null){
          router.push({path: workStore.learningStartPage.path})
          .then(async()=> workStore.saveIsLearningMode(false)).catch(()=>{})
        }else{
          router.push({name:'top'}).then(()=> workStore.saveIsLearningMode(false)).catch(()=>{})
        }
      }
      // else if question search by question id then go to learning start page
      else if(workStore.isSearchQuestionById){
        workStore.saveIsLearningPage(false)
        if(workStore.learningStartPage!=null){
          router.push({path: workStore.learningStartPage.path})
          .then(()=> workStore.saveIsLearningMode(false)).catch(()=>{})
        }else{
          router.push({name:'top'}).then(()=> workStore.saveIsLearningMode(false)).catch(()=>{})
        }
      }
      // else if all question are skip then go to learning start page
      else if(skipAll){
        // delete study break data
        workStore.deleteStudyBreakData()
        workStore.saveIsLearningPage(false)
        workStore.saveIsMissionQuestion(false)
        let path = !!workStore.learningStartPage?workStore.learningStartPage.path:'top'
        workStore.saveLearningStartPage(null)
        router.push({path:path}).then(()=> workStore.saveIsLearningMode(false))
      }
      // show final result modal(S3-10 page)
      else{
        // disabled tabindex after submit result
        tabIndex.value = -1
        // prevent continuous enter press
        const focusElement: any = document.activeElement
        if(focusElement) {
          focusElement.blur()
        }
        totalNumberOfCorrectAnswer.value = numberOfCorrectAnswer.value + preNumberOfCorrectAnswer.value
        openModal('finalResult')
      }
    }
    // go to next question or answer depends on condition
    else {
      // if next question is already answered then just update question index and stay same(S3-9) page
      // NFR-5682: "workStore.isPrevQuestionHistory" for avoid error during latest history checking
      if(workStore.isPrevQuestionHistory || (workStore.questionCorrectWrongList[qIndex.value + 1]?.progress==1 && workStore.questionCorrectWrongList[qIndex.value + 1]?.result !== null)){
        workStore.saveIsDisabledButton(false)
        workStore.saveQIdx(qIndex.value + 1)
        qIndex.value++
        processing.value = false
        setDocumentTitle()
        questionBodyHeight()
      }
      // else update question index and go to next question S3-7 page
      else{
        workStore.saveQIdx(qIndex.value + 1)
        router.push({name:'question'})
            .then(() => {
              workStore.saveQuestionStudyStartTime()
            })
            .catch(() => {})
      }
    }
  }
  function prevAnswer(){
    let prevCorrectWrong = workStore.questionCorrectWrongList[qIndex.value-1]
    // if previous question answer is skip the route to S3-7
    if(prevCorrectWrong.progress == 1 && prevCorrectWrong.result == null){
      workStore.saveQIdx(qIndex.value - 1)
      router.push({name: "question"}).then(async() => {
      }).catch(() => {})
    }
    else {
      workStore.saveQIdx(qIndex.value - 1)
      qIndex.value--
      workStore.saveIsPrevQuestionAnswerButton(true)
      setDocumentTitle()
      questionBodyHeight()
    }
  }
  function setDocumentTitle(){
    if(workStore.isReviewQuestion){
      document.title = "要復習問題" + (qIndex.value + 1) + " | "
          + remove_markdown(workStore.selectedWork[workStore.selectedWorkIndex].name)
    }else{
      document.title = workStore.questions[qIndex.value].sort_order + " | "
          + remove_markdown(selectedQuestionSetTitle.value)+ " | "
          + remove_markdown(workStore.selectedWork[workStore.selectedWorkIndex].name)
    }
  }
  function questionBodyHeight(){
    nextTick(() =>{
      if(globalNavigationStore.selectedColor=='kokugo') {
        let headerH = document.getElementsByClassName("p-question__header")[0]?.clientHeight || 75;
        let mainBoxH = document.documentElement.clientHeight;
        let questionInnerH: any = refModQuestionInner.value
        questionInnerH.style.height = (mainBoxH - headerH) + 'px';
      }else{
        let mainBoxH = document.documentElement.clientHeight;
        let headerH = document.getElementsByClassName("p-question__header")[0]?.clientHeight || 75;
        let footerH = document.getElementsByClassName("p-question__footer")[0].clientHeight;
        let questionBodyH:any = refModQuestionBody.value
        questionBodyH.style.height = (mainBoxH - headerH - footerH - 60) + 'px';
      }
      // 「前回の学習を確認」系以外から来た時（「全問題を学習」、「始める」など）
      if(!workStore.isPrevQuestionHistory){
        if(workStore.isPrevQuestionAnswerButton){ // S3-7, S3-9の「前回の問題へ」ボタンが押されたときスクロールは一番上に
          let questionBodyTop:any = refQuestionBody.value
          questionBodyTop.scrollIntoView({block: "start", inline: "nearest"})
        }else{ // 上記以外の場合は解説どころまでスクロール移動
          let answerExplanation:any = refAnswerExplanation.value
          answerExplanation.scrollIntoView({block: "start", inline: "nearest"})
        }
      }
      workStore.saveIsPrevQuestionAnswerButton(false)
    });
  }
  async function solveWrongAnswerOnly(){
    audioPlayer.backGroundSound().stop()
    if(accountStore.isSoundEnabled){audioPlayer.startSound().play()}
    workStore.saveMission(null)
    workStore.saveQIdx(0)
    workStore.saveIsWronglyAnswered(true)
    // sync to local and store variable to avoid out of index problem
    qIndex.value = 0
    globalNavigationStore.fetchNavAccountStatus({isMission: true})
    workStore.saveLatestQuestionHistories(workStore.initialAnswer)
    const unsolvedQuestions = getUnsolvedQuestion.value
    const question_len = unsolvedQuestions.length
    if(question_len>0){
      workStore.saveQuestions(unsolvedQuestions)
      let question_ids = unsolvedQuestions.map(item => item.id )
      workStore.saveQuestionIds(question_ids)
      let questionCorrectWrongList = question_ids.map((item) => {
        return {
          result: null,
          progress: 0
        }
      })
      workStore.saveIsUnanswered(true)
      await workStore.initializeAnswer()
      createLatestQuestionHistories();
      // NFR-5991: Initialize a variable to get question_set_id
      const question_set_id = Number(Object.keys(selectedQuestionSet)[0]);
      // NFR-5991: if question_set_id is not null then save study break data
      if(question_set_id){
        // NFR-5116: initilize study break data
        saveInitialStudyBreakData(workStore, question_set_id, questionCorrectWrongList, local_time(), null, null, getLatestBreakDataVersion(), STUDY_TARGET_KIND.LEARN_UNANSWERED_QUESTIONS)
      }
      router.push({name:'question'}).then(async() => {
        workStore.saveQuestionCorrectWrongList(questionCorrectWrongList)
      })
    }
  }
  function solveRemainingProblems(){
    audioPlayer.backGroundSound().stop()
    if(accountStore.isSoundEnabled){audioPlayer.startSound().play()}
    workStore.saveQIdx(0)
    // sync to local and store variable to avoid out of index problem
    qIndex.value = 0
    let new_questions: Array<any> = []
    if(remainingQuestions.value>15){
      new_questions = workStore.remainQuestion.slice(0, 10)
      setTimeout(() => {
        workStore.remainQuestion.splice(0, 10)
      }, 300)
    }else{
      new_questions = workStore.remainQuestion.slice(0, 15)
      setTimeout(() => {
        workStore.remainQuestion.splice(0, 15)
      }, 300)
    }
    workStore.saveQuestions(new_questions)
    let question_ids = new_questions.map(item => item.id )
    workStore.saveQuestionIds(question_ids)
    let questionCorrectWrongList = question_ids.map((item) => {
      return {
        result: null,
        progress: 0
      }
    })
    workStore.fetchQuestionProgress({question_ids: question_ids})
    workStore.initializeAnswer()
    if(isEnvCaptureGoogleAnalyticsEvents() && workStore.isReviewQuestion){
      let review_kind = REVIEW_REQUIRED.SECTION_REVIEW
      if(workStore.isChapterReview){
        review_kind = REVIEW_REQUIRED.CHAPTER_REVIEW
      }
      event('start_study', {
        'subject_field': subject_field,
        'study_target_kind': STUDY_TARGET_KIND.LEARN_REVIEW_TAG_NEXT_QUESTION,
        'review_kind': review_kind,
        'work_id': workStore.selectedWork[workStore.selectedWorkIndex]?.id,
        'target_question_count': questionCorrectWrongList.length
      })
    }
    // NFR-5991: Initialize a variable to get question_set_id
    const question_set_id = Number(Object.keys(selectedQuestionSet)[0]);
    // NFR-5991: if question_set_id is not null then save study break data
    if(question_set_id){
      // NFR-5116: initilize study break data
      saveInitialStudyBreakData(workStore, question_set_id, questionCorrectWrongList)
    }
    router.push({name:'question'}).then(()=>{
      workStore.saveQuestionCorrectWrongList(questionCorrectWrongList)
      workStore.saveTotalNumOfQuestion(question_ids.length)
    })
  }
  function goNextQuestionSet(){
    audioPlayer.backGroundSound().stop()
    if(accountStore.isSoundEnabled){audioPlayer.startSound().play()}
    if(!!learningStartPage){
      let params = {}
      if(learningStartPageName == "work"){
        params = learningStartPageParams
      }else if(learningStartPageName == "chapter"){
        params = {
          "chapter_id": workStore.nextQuestionSet.chapter_id,
        }
      }
      workStore.saveIsLearningPage(false)
      router.push({name: learningStartPageName, params: params, query: {p:"openModal"}}).then(()=> workStore.saveIsLearningMode(false))
    } else {
      workStore.saveIsLearningPage(false)
      router.push({name: "chapter", params: {"chapter_id": workStore.nextQuestionSet.chapter_id}}).then(()=> workStore.saveIsLearningMode(false))
    }
  }

  function focusFirstElement(index) {
    let answerArea:any;
    if(isJapanese.value){
      answerArea = document.getElementsByClassName("p-question__inner")
    }else{
      answerArea = document.getElementsByClassName("c-accordion__cont")
    }
    if(answerArea.length){
      const focusableElements = [...answerArea[0].querySelectorAll('[tabindex="0"]')]
      if (focusableElements.length === 1) {
        focusableElements[0]?.focus()
      } else {
        focusableElements[index]?.focus()
      }
    }
  }
  /**
   * This is a function name 'skipNext' which skip the current question and go to next one
   */
  function skipNext(){
    const nextIndex = qIndex.value + 1
    // check next question is last one
    if(workStore.questionIds.length == nextIndex){
      // if all question are skip then return to learning start page
      let skipAll = workStore.questionCorrectWrongList.every(item => item.progress==1 && item.result==null)
      if(skipAll){
        workStore.saveIsLearningPage(false)
        // stop animation in top page for skip all question
        workStore.saveIsMissionQuestion(false)
        let path = !!workStore.learningStartPage?workStore.learningStartPage.path:null
        // stop animation for chapter and work page
        workStore.saveLearningStartPage(null)
        // avoid page error
        if(path){
          router.push({path:path}).then(()=> workStore.saveIsLearningMode(false))
        }
      }
      // if next question is last question and any question is asnwered then go to S3-10 modal.
      else {
        // setting study end time for current question
        workStore.saveQuestionStudyEndTime()
        // correction of total correct answer if skip next press from last answer
        totalNumberOfCorrectAnswer.value = numberOfCorrectAnswer.value + preNumberOfCorrectAnswer.value
        openModal('finalResult')
      }
    }
    // if next question is already answered then go to S3-9 page
    else if(nextIndex < workStore.questionCorrectWrongList.length && workStore.questionCorrectWrongList[nextIndex]?.progress==1 && workStore.questionCorrectWrongList[nextIndex]?.result!=null){
      workStore.saveQIdx(nextIndex)
      qIndex.value++
    }
    // if next question is not answered then go to S3-7 page. 
    else{
      workStore.saveQIdx(nextIndex)
      // setting study start time for next question
      workStore.saveQuestionStudyStartTime()
      router.push({name: 'question'}).catch(()=>{})
    }
  }
  /**
   * This is a function name 'skipPrev' which go to previous question based on condition
   */
   function skipPrev(){
    // 現在の質問インデックスから1引いた前の質問インデックスを計算
    const prevIndex = qIndex.value - 1;
    // NFR-5267 前の質問インデックスが有効な範囲内かチェック
    if (prevIndex >= 0 && prevIndex < workStore.questionCorrectWrongList.length) {
      // if previous question is skip state then go to S3-7 for previous question
      if(workStore.questionCorrectWrongList[prevIndex].progress==1 && workStore.questionCorrectWrongList[prevIndex].result==null){
        workStore.saveQIdx(prevIndex)
        // setting study start time for prev question
        workStore.saveQuestionStudyStartTime()
        router.push({name: 'question'}).catch(() => {})
      }
      // previous question is already answered then go to  S3-9 for previous question 
      else {
        workStore.saveQIdx(prevIndex)
        qIndex.value--
        setDocumentTitle()
        questionBodyHeight()
      }
    }
  }
  function preventContextmenu(event:Event){
    // NFR-4573, if student is not debug mode then disabled context menu
    if(!accountStore.isDebug){
      event.preventDefault()
    }
  }
  function preventCopy(event:Event){
    // NFR-4573, if student is not debug mode then disabled CTRL + c to copy text
    if(!accountStore.isDebug){
      event.preventDefault()
    }
  }
  function handleMouseUp() {
    // NFR-4573, if student is not debug mode then disabled Edge browser mini-context menu
    if(!accountStore.isDebug){
      hideMiniContextMenuOnEdge()
    }
  }
  // NFR-5457: confetti animation module
  function startConfettiAnimation() {
    // confetti animation colors
    const colors = ['#00A7EB','#E63F8F','#FEF10C','#8CC21E'];
    // animation end time
    const end = Date.now() + (1 * 1000);
    (function frame() {
      // launch a few confetti from the left edge
      confetti({
        particleCount: 4,
        angle: 60,
        spread: 55,
        origin: { x: 0 },
        scalar: 1.2,
        colors: colors
      });
      // launch a few confetti from the right edge
      confetti({
        particleCount: 4,
        angle: 120,
        spread: 55,
        origin: { x: 1 },
        scalar: 1.2,
        colors: colors
      });
      // Style the default canvas
      const canvas = document.querySelector("canvas");
      if(canvas){
        // set this z-index to visiable animation because final modal have z-index value 1001
        canvas.style.zIndex = "9999";
      }
      if (Date.now() < end) {
        requestAnimationFrame(frame);
      }
    }());
  }
  // NFR-5267 storeのquestionIndexの変化を監視してqIndexを更新
  watch(() => workStore.questionIndex, (newIndex) => {
    qIndex.value = newIndex;
  });
</script>
